import React, { Component } from "react";
import ReactTour from "reactour";
import ReactTourContent from "./tour-content";

class Tour extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTourOpen: false
    };
  }

  onFinishTour(e) {
    if (this.props.onCloseTour) {
      this.props.onCloseTour()
    }
    this.setState({
      ...this,
      isTourOpen: false
    });
  }

  componentDidMount() {

    if (this.props.delay) {
      setTimeout(() => {
        this.setState({
          ...this,
          isTourOpen: true
        });
      }, 1000);
    } else {
      this.setState({
        ...this,
        isTourOpen: true
      })
    }
  }
  render() {
    return (
      <ReactTour
        rounded={6}
        showCloseButton={false}
        showButtons={true}
        disableInteraction
        showNavigation={false}
        badgeContent={(x, y) => <i onClick={() => {
          this.onFinishTour()
        }} className="fas fa-close btn"></i>}
        steps={this.props.steps}
        isOpen={this.state.isTourOpen}
        onRequestClose={() => { }}
      />
    );
  }
}

export default Tour;
export { ReactTourContent };



// WEBPACK FOOTER //
// ./src/components/theme/tour/index.jsx